var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5908 7.10083L17.8335 11.3436L8.28755 20.8896H4.0448V16.6468L13.5908 7.10083ZM18.894 3.91858L21.015 6.03958C21.6008 6.62533 21.6008 7.57483 21.015 8.16058L18.894 10.2816L14.6513 6.03883L16.7723 3.91783C17.358 3.33208 18.3075 3.33208 18.8933 3.91783L18.894 3.91858Z",
    fill: "#333333"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPolygon);
export default __webpack_public_path__ + "static/media/EditPolygon.8fca277ee25dac1ffdf20ebc0229902f.svg";
export { ForwardRef as ReactComponent };